const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Verslastoimisto",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veterinarasasema",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Privaloma",
    },
  },
  salutation: {
    label: "Kreipinys",
    placeholder: "Pasirinkite kreipinį",
    errors: {
      required: "Kreipinys yra privalomas",
      invalid: "Pasirinkite galiojantį kreipinį",
    },
  },
  firstName: {
    label: "Vardas",
    placeholder: "Jonas",
    errors: {
      required: "Vardas yra privalomas",
      minLength: "Vardas turi būti bent 2 simboliai",
      maxLength: "Vardas gali būti ne daugiau kaip 50 simbolių",
    },
  },
  lastName: {
    label: "Pavardė",
    placeholder: "Jonaitis",
    errors: {
      required: "Pavardė yra privaloma",
      minLength: "Pavardė turi būti bent 2 simboliai",
      maxLength: "Pavardė gali būti ne daugiau kaip 50 simbolių",
    },
  },
  email: {
    label: "El. paštas",
    placeholder: "jonas.jonaitis@pavyzdys.lt",
    description:
      "Įveskite asmeninį el. pašto adresą, o ne bendrinamą el. pašto adresą.",
    prefixWarningTitle: "Aptikta bendra pašto dėžutė",
    prefixWarningDescription:
      "Rekomenduojame naudoti asmeninį el. pašto adresą geresniam ir labiau pritaikytam patyrimui",
    errors: {
      required: "El. paštas yra privalomas",
      invalidEmail: "Įveskite galiojantį el. pašto adresą",
      emailAssociatedWithYourAccount:
        "Jūsų el. pašto adresas susietas su jūsų paskyra ir negali būti pakeistas.",
    },
  },
  confirmEmail: {
    label: "Patvirtinkite el. paštą",
    placeholder: "jonas.jonaitis@pavyzdys.lt",
    errors: {
      required: "El. pašto patvirtinimas yra privalomas",
      invalidEmail: "Įveskite galiojantį el. pašto adresą",
      emailMatchError: "El. pašto adresai nesutampa",
    },
  },
  password: {
    label: "Slaptažodis",
    placeholder: "Įveskite savo slaptažodį",
    errors: {
      required: "Slaptažodis yra privalomas",
    },
  },
  confirmPassword: {
    label: "Patvirtinkite slaptažodį",
    placeholder: "Patvirtinkite savo slaptažodį",
    errors: {
      required: "Slaptažodžio patvirtinimas yra privalomas",
      passwordMatchError: "Slaptažodžiai nesutampa",
    },
  },
  addressLine1: {
    label: "Adrešo eilutė 1",
    placeholder: "Gedimino pr. 123",
    errors: {
      required: "Adrešo eilutė 1 yra privaloma",
      minLength: "Adrešo eilutė 1 turi būti bent 5 simboliai",
      maxLength: "Adrešo eilutė 1 gali būti ne daugiau kaip 100 simbolių",
    },
  },
  addressLine2: {
    label: "Adrešo eilutė 2",
    placeholder: "Butas 4B",
    errors: {
      required: "Adrešo eilutė 2 yra privaloma",
      maxLength: "Adrešo eilutė 2 gali būti ne daugiau kaip 100 simbolių",
    },
  },
  city: {
    label: "Miestas",
    placeholder: "Vilnius",
    errors: {
      required: "Miestas yra privalomas",
      minLength: "Miestas turi būti bent 2 simboliai",
      maxLength: "Miestas gali būti ne daugiau kaip 50 simbolių",
    },
  },
  country: {
    label: "Šalis",
    placeholder: "Pasirinkite šalį",
    errors: {
      required: "Šalis yra privaloma",
      invalid: "Pasirinkite galiojančią šalį",
    },
  },
  state: {
    label: "Valstija",
    placeholder: "Pasirinkite valstiją",
    errors: {
      required: "Valstija yra privaloma",
      invalid: "Pasirinkite galiojančią valstiją",
    },
  },
  jurisdiction: {
    label: "Licencijos jurisdikcija",
    placeholder: "Pasirinkite licencijos jurisdikciją",
    errors: {
      required: "Licencijos jurisdikcija yra privaloma",
      invalid: "Pasirinkite galiojančią jurisdikciją",
    },
  },
  zipCode: {
    label: "Pašto kodas",
    placeholder: "01001",
    errors: {
      required: "Pašto kodas yra privalomas",
      invalid: "Įveskite galiojantį pašto kodą",
    },
  },
  role: {
    label: "Vaidmuo",
    placeholder: "Pasirinkite savo vaidmenį",
    errors: {
      required: "Pasirinkite savo vaidmenį",
      invalid: "Pasirinkite galiojantį vaidmenį",
    },
  },
  businessType: {
    label: "Verslo tipas",
    placeholder: "Pasirinkite verslo tipą",
    errors: {
      required: "Verslo tipas yra privalomas",
      invalid: "Pasirinkite galiojantį verslo tipą",
    },
  },
  businessName: {
    label: "Verslo pavadinimas",
    placeholder: "Įveskite verslo pavadinimą",
    errors: {
      required: "Verslo pavadinimas yra privalomas",
      minLength: "Verslo pavadinimas turi būti bent 2 simboliai",
      maxLength: "Verslo pavadinimas gali būti ne daugiau kaip 100 simbolių",
    },
  },
  businessSearch: {
    label: "Verslo paieška:",
    addNewAccount: "Pridėti naują verslo paskyrą",
    canNotFindBusiness: "Nerandate savo verslo?",
    guideline:
      "Įveskite savo pašto kodą ir tada pasirinkite iš toliau pateikto sąrašo.",
    guidelineForNameSearch:
      "Įveskite pilną verslo pavadinimą ir tada pasirinkite iš sąrašo.",
    placeholder: "Kur dirbate?",
    noResults: "Rezultatų nerasta",
    searching: "Ieškoma...",
    selectedBusinessHeading: "Pasirinktas verslas:",
    selectedBusinessNotCorrect: "Neteisingai?",
    selectedBusinessTryAgain: "Bandykite dar kartą",
    selectedBusinessDismiss: "Atmesti verslą",
    resultsFound: {
      singular: "Rastas 1 verslas",
      plural: "Rasti keli verslai",
    },
    errors: {
      network:
        "Kilo problemų jungiantis prie verslo paieškos paslaugos. Bandykite dar kartą vėliau.",
    },
  },
  explicitConsent: {
    label:
      "Pažymėdamas šį langelį sutinku su Elanco naudojimo sąlygomis ir patvirtinu, kad Elanco rinks ir tvarkys mano asmens duomenis pagal Elanco privatumo politiką",
    errors: {
      required: "El. pašto sutikimas yra privalomas",
    },
  },
  explicitSmsConsent: {
    label:
      "Pažymėdamas šį langelį sutinku gauti Elanco rinkodaros pranešimus SMS/tekstine žinute.",
    errors: {
      required: "Būtinas sutikimas gauti SMS",
    },
  },
  telephone: {
    label: "Asmeninis telefonas",
    placeholder: "Įveskite savo asmeninį telefono numerį",
    dialCodeLabel: "Kodas",
    dialCodePlaceholder: "Ieškoti šalies…",
    errors: {
      invalid: "Įveskite galiojantį telefono numerį.",
    },
  },
  businessTelephone: {
    label: "Verslo telefonas",
    placeholder: "Įveskite verslo telefono numerį",
    dialCodeLabel: "Kodas",
    dialCodePlaceholder: "Ieškoti šalies…",
    errors: {
      invalid: "Įveskite galiojantį telefono numerį.",
    },
  },
  professionalNumber: {
    label: "Profesinis numeris",
    placeholder: "1234567",
    errors: {
      required: "Įveskite profesinį numerį",
      maxLength: "Įvestis viršija simbolių limitą",
    },
  },
  addressSearch: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  businessSearchField: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  checkbox: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  combobox: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  datePicker: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  dateRange: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  dateTime: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  emailField: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  fileInput: {
    errors: {
      required: "Pasirinkite failą",
    },
  },
  number: {
    errors: {
      required: "Įveskite skaičių",
      minValue: "Įveskite vertę, didesnę už minimalią",
      maxValue: "Įveskite vertę, mažesnę už maksimalią",
    },
  },
  passwordField: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  rangeSlider: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  select: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  telephoneField: {
    errors: {
      required: "Įveskite tik skaičius",
      invalidTelephone: "Įveskite galiojantį telefono numerį",
      invalidFormat: "Neteisingas numerio formatas",
    },
  },
  text: {
    errors: {
      required: "Naudokite tik raides (A-Z), skaičius (0-9) ir jokių simbolių",
      maxLength: "Įvestis viršija simbolių limitą",
      minLength: "Įvestis turi būti bent 2 simboliai",
    },
  },
  textarea: {
    characters: "merkkiä",
  },
  time: {
    errors: {
      required: "Šis laukas yra privalomas",
    },
  },
  form: {
    errors: {
      generic: "Įvyko klaida pateikiant formą. Bandykite dar kartą.",
      reportAnIssue: "Praneškite apie problemą.",
      configuration: "Konfigūracijos klaida",
      noFormQuestionsAvailable: "Formos klausimų nėra.",
      formComponentLoad:
        "Formos komponento nepavyko užkrauti dėl nepalaikomo lauko.",
      code: "Kodas",
      type: "Tipas",
      missingRequiredFields:
        "Šioje formoje trūksta būtinų laukų (El. paštas ir/arba Sutikimas). Kreipkitės į administratorių, kad ištaisytų formos konfigūraciją.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Veterinaras",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Gamintojas - Mišrus/Kitas",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Mažmenininkas",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Avių augintojas",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veterinaras",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Veterinaras", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veterinaras, Vastanoton omistaja",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veterinarasavustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veterinarasasema - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veterinarasasema - Veterinaras",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veterinarasasema - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinarasasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinaras",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Ponas",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Ponas",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Ponia",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Ponia/Neiti",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesorius",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
